import { useState } from 'react'
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { Paper } from '@mui/material';
import api from '../../../../services/api';
import LoadingShort from '../../../../load/loadingShort';
import MessageError from '../../../../messages/messageError';
import { useNavigate } from 'react-router-dom';

export default function SearchSolicitacaoImportacao() {
    const [loading, setLoading] = useState(false);
    const [solicitacaoId, setSolicitacaoId] = useState('');
    const [messageError, setMessageError] = useState('');
    const navigate = useNavigate()

    const buscarSolicitacao = (e) => {
        e.preventDefault()
        setLoading(true)
        setMessageError('')
        api.get(`/solicitacao-importacao-by-solicitacaoId/${solicitacaoId}`)
            .then(response => {

                if (response.data.solicitacaoImportacao?.status === 'Aprovado' && !response.data.solicitacaoImportacao?.certificado) {
                    navigate(`/utente/solicitacao/desalfandegamento/${response.data.solicitacaoImportacao._id}`)
                } else {
                    navigate(`/utente/solicitacao/importacao/${response.data.solicitacaoImportacao._id}`)
                }
            }).catch(err => {
                setMessageError(err.response.data.message)
            }).finally(() => setLoading(false))
    }

    return (
        <form onSubmit={buscarSolicitacao} >
            {messageError && <MessageError message={messageError} />}

            <Paper
                className='solicitacao-status'
                // component="form"
                sx={{ p: '8px 15px', display: 'flex', alignItems: 'center', background: '#85285e', borderRadius: 10 }}
            >
                <InputBase
                    // autoFocus
                    sx={{ ml: 1, flex: 1, color: '#fff' }}
                    value={solicitacaoId}
                    onChange={(e) => setSolicitacaoId(e.target.value)}
                    placeholder={'Insira o ID da sua solicitação para consultar'}
                />
                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />

                <IconButton type="submiy" disabled={!solicitacaoId} style={{ color:  '#fff' }} sx={{ p: '10px' }} aria-label="search">
                    {loading ? <LoadingShort /> : <SearchIcon color='inherit' />}
                </IconButton>
            </Paper>
        </form>
    )
}
